export default "__VITE_ASSET__RDIw6PwP__"